<!-- <head>
  <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests">
</head> -->
<!-- <div class="page-layout carded fullwidth inner-scroll">

    <div class="top-bg primary"></div>

    <div class="center">

        <div class="header primary p-16 p-sm-24" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button class="mr-16" [routerLink]="'/results/trust_index'">
                    <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="m-0 cabecera">{{'RESULTADOS.SECCIONES.'+origen+'.TITULO' | translate}}</div>
        </div>

        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
            <div class="toolbar px-24 py-8">

            </div>
            <div class="content p-24" fusePerfectScrollbar > -->

            <!-- <form action="http://35.247.132.129/CGoReporting/index.jsp" method="post" id="RecDatos" target="frameTableau">
                <input name="atoken" type="hidden" value="999e72f4-ba5c-4906-aea2-8532488883d4">
                <input name="ctoken" type="hidden" value="QI27FW37P">
                <input name="email" type="hidden" value="ipg@gptwonline.com">
                <input name="utype" type="hidden" value="5">
                <input name="brk" type="hidden" value="1">
                <input name="pid" type="hidden" value="">
                <input name="lang" type="hidden" value="18">
            </form> -->

            <!-- <form action="http://35.247.132.129/CGoReporting/index.jsp" method="post" id="RecDatos2" target="frameTableau">
                <input name="atoken" type="hidden" value="999e72f4-ba5c-4906-aea2-8532488883d4">
                <input name="ctoken" type="hidden" value="12345">
                <input name="email" type="hidden" value="ipg@gptwonline.com">
                <input name="utype" type="hidden" value="1">
                <input name="brk" type="hidden" value="1">
                <input name="pid" type="hidden" value="">
                <input name="lang" type="hidden" value="18">
            </form> -->
            <div fxLayout="column" fxFlex="100" fxLayoutAlign="center center">
              <ng-container *ngIf="cargando">
                <div fxLayout="row wrap" fxLayoutAlign="center center" [@animateStagger]="{value:'50'}">
                  <div fxFlex="100" fxLayout="column" fxLayoutAlign="center center"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                      <h2>{{'RESULTADOS.CARGANDO' | translate}}</h2>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!cargando">
                <!-- <form action="{{urlTableau}}" method="post" id="RecDatos" target="frameTableau"> -->
                  <!-- <input name="atoken" type="hidden" value="{{tokenTableau}}">
                  <input name="ctoken" type="hidden" value="{{ctoken}}">
                  <input name="email" type="hidden" value="{{user}}">
                  <input name="utype" type="hidden" value="{{ulvl}}">
                  <input name="brk" type="hidden" value="{{broker}}">
                  <input name="lang" type="hidden" value="{{langCode}}"> -->
                <!-- </form> -->

                <iframe name="frameTableau" allow="fullscreen" [src]="urlSafe"></iframe>
              </ng-container>
            </div>
<!--
            </div>

        </div>

    </div>

</div> -->
